
import { defineComponent } from 'vue'
import { message } from 'ant-design-vue'
import ImageProcesser from './ImageProcesser.vue'
import StyledUploader from './StyledUploader.vue'
import { RespUploadData } from '../store/respTypes'
export default defineComponent({
  components: {
    ImageProcesser,
    StyledUploader
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  emits: ['change'],
  setup(props, context) {
    const onImageUploaded = (data: { resp: RespUploadData; file: File }) => {
      const { resp } = data
      message.success('上传成功')
      context.emit('change', resp.data.urls[0])
    }
    const handleUploadUrl = (url: string) => {
      context.emit('change', url)
    }
    return {
      onImageUploaded,
      handleUploadUrl
    }
  }
})
